var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_drop_right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M14.5391 11.6159L11.6243 9.18691C10.489 8.24083 9.92135 7.76779 9.46068 7.98356C9 8.19933 9 8.93824 9 10.4161V13.5839C9 15.0618 9 15.8007 9.46068 16.0164C9.92135 16.2322 10.489 15.7592 11.6243 14.8131L11.6243 14.8131L14.5391 12.3841C14.7527 12.2061 14.8595 12.1171 14.8595 12C14.8595 11.8829 14.7527 11.7939 14.5391 11.6159Z",
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow_right_white.59a3510ce66a7e1e24b7a479e8b79b8a.svg";
export { ForwardRef as ReactComponent };